export default __webpack_public_path__ + "static/media/trash.d798b9df.svg";